export interface PostChatMessageBody {
  messages: Array<{ content: string; role: string }>;
  context?: { accessToken?: string; entraToken?: string };
  url?: string;
  sessionId: string;
}

export async function postChatMessageService(body: PostChatMessageBody) {
  const apiUrl = import.meta.env.VITE_API_URL;
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (body.context?.accessToken) {
    headers["Authorization"] = `Bearer ${body.context.accessToken}`;
  }

  if (body.context?.entraToken) {
    headers["X-DA-Entra-AccessToken"] = body.context.entraToken;
  }

  const lastMessageList = body.messages.slice(-1);
  body.messages = lastMessageList;

  const fullUrl = `${apiUrl}/triage`;
  const response = await fetch(fullUrl, {
    method: "POST",
    headers,
    credentials: "include",
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      `API error: ${response.status}: ${response.statusText}\n${errorText}`,
    );
  }
  return response
}
